<div class="radio-container">
  <ng-container *ngFor="let name of fieldInfo?.translations">
    <div class="d-flex align-items-center mb-2" *ngIf="name.lang === panelLanguage">
      <h5 class="radio-header">{{ name.label | uppercase }}</h5>
      <div class="info-icon" *ngIf="name.help">
        <h4>
          <nb-icon icon="info" pack="icomoon" [ngbTooltip]="name.help" container="body"></nb-icon>
        </h4>
      </div>
    </div>
  </ng-container>
  <div class="options-container">
    <div *ngFor="let value of radioValues; let i = index" class="radio-button-container">
      <label class="container"
        >{{ value }}
        <input type="radio" [id]="value" [name]="value" [checked]="checkedValue === value" (change)="getValue(value)" />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
</div>
